import React from 'react'
import { SingleDatePicker } from 'react-dates';

import Button from '../common/button'

const searchButtonStyle = { width: '60%', padding: 0, margin: '2px 0px 30px 20px' }

const SearchInputsComponent = (props) => {
  return (
    <div className="row">
      <div className="col-xs-4 paddingRight20 etm-tickets-date">
        <SingleDatePicker
          id="start_date"
          daySize={30}
          date={props.startDate}
          placeholder="Select Date"
          displayFormat="DD-MM-YYYY"
          focused={props.focusedStartDate}
          hideKeyboardShortcutsPanel={true}
          onDateChange={props.onStartDateChange}
          onFocusChange={props.onStartFocusChange}
          isOutsideRange={props.startDateRangeChecker}
        />
      </div>
      <div className="col-xs-2 paddingLeft20">
        <select
          className="deal-discount-type deal-type-select"
          value={props.routeName}
          onChange={props.onRouteChange}
          placeholder="Select Route"
        >
          <option disabled value="-1">Select Route</option>
          {
            props.etmRoutes.map(el => <option key={el.key} value={el.key}>{el.name}</option>)
          }
        </select>
      </div>
      <div className="col-xs-2 paddingLeft20">
        <select
          className="deal-discount-type deal-type-select"
          value={props.direction}
          onChange={props.onDirectionChange}
          placeholder="Select Direction"
        >
          <option disabled value="-1">Select Direction</option>
          {
            props.directions.map(el => <option key={el.key} value={el.key}>{el.name}</option>)
          }
        </select>
      </div>
      <div className="col-xs-4 service-search-button">
        <Button styleObj={searchButtonStyle} label="Search" onButtonClick={props.onSearchClick} />
      </div>
    </div>
  )
}

export default SearchInputsComponent;